const LEADING_NUMBER_REGEX = /^\s*(\d+)(.*)$/;

function compareText(a: string, b: string): number {
  return a.localeCompare(b, 'en', { sensitivity: 'base' }) || (a < b ? -1 : a > b ? 1 : 0);
}

/**
 * Sorts local names the way people read them: names starting with a number come first in numeric order
 * ("5", "63", "63 OCU", "500"), then the rest A–Z ("AKLD", "ARA", "IBU"). Empty names go last.
 */
export function compareLocalNames(a: string | null | undefined, b: string | null | undefined): number {
  const nameA = (a || '').trim();
  const nameB = (b || '').trim();

  if (!nameA || !nameB) {
    return nameA ? -1 : nameB ? 1 : 0;
  }

  const numberMatchA = LEADING_NUMBER_REGEX.exec(nameA);
  const numberMatchB = LEADING_NUMBER_REGEX.exec(nameB);

  if (numberMatchA && numberMatchB) {
    const numberDifference = +numberMatchA[1] - +numberMatchB[1];

    if (numberDifference) {
      return numberDifference;
    }

    return compareText(numberMatchA[2].trim(), numberMatchB[2].trim()) || compareText(nameA, nameB);
  }

  if (numberMatchA || numberMatchB) {
    return numberMatchA ? -1 : 1;
  }

  return compareText(nameA, nameB);
}

export function sortByLocalName<T>(records: T[], getName: (record: T) => string = (record: any) => record.name): T[] {
  return [...records].sort((a, b) => compareLocalNames(getName(a), getName(b)));
}
